import type { TrackingStopStatus, TrackingVehicleType } from './pickupTrackingTypes';

/** 车型色板（原型 cool 方案）与车身高度；宽度固定 34 */
export const VEHICLE_THEME: Record<TrackingVehicleType, { color: string; height: number }> = {
    van: { color: '#5eead4', height: 46 },
    t26: { color: '#3b82f6', height: 56 },
    t53: { color: '#f4b860', height: 66 },
};

export const VEHICLE_TYPES: TrackingVehicleType[] = ['van', 't26', 't53'];

/** 非三档车型：中性灰、按 van 车身画 */
export const UNKNOWN_VEHICLE_THEME = { color: '#94a3b8', height: 46 };

export const vehicleThemeOf = (type: TrackingVehicleType | null): { color: string; height: number } =>
    type ? VEHICLE_THEME[type] : UNKNOWN_VEHICLE_THEME;

export const STOP_STATUS_COLOR: Record<TrackingStopStatus, string> = {
    ok: '#34d399',
    fail: '#f87171',
    cur: '#8fb4d4',
    wait: '#8fb4d4',
};

export const LONG_STAY_COLOR = '#dc2626';
export const ALERT_COLOR = '#ef4444';
export const HUB_COLOR = '#e2e8f0';
